import React from "react"
import { Container, Row, Col } from "reactstrap"
import "./MykaV2ContactCta.scss"

const MykaV2ContactCta = ({ heading, body, ctaLabel, email }) => {
  return (
    <section className="myka-v2-contact-cta">
      <div className="myka-v2-contact-cta__bg-vector" aria-hidden="true">
        <svg width="1500" height="784" viewBox="0 0 1500 784" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M741.039 68.5233C346.788 135.368 146.431 45.6823 -0.000631407 3.00444e-05L-0.000366212 782.999L1500 783.006L1500 68.5232C1347.59 45.6821 1196 -8.61408 741.039 68.5233Z" fill="#3B86FF"/>
          <g opacity="0.15" style={{ mixBlendMode: 'multiply' }}>
            <path d="M811.545 400.215C1109.52 -35.5993 1500 131.458 1500 131.458L1500 783.007L-0.00048845 783.003L-0.00053866 508.316C247.865 576.121 619.17 630.068 811.545 400.215Z" fill="#3B86FF"/>
          </g>
          <g opacity="0.15" style={{ mixBlendMode: 'multiply' }}>
            <path d="M0.000488281 782.995L1500 782.995L1500 523.389C1183.37 461.659 626.897 801.855 317.771 394.465C192.285 229.091 81.0942 173.193 0.000488281 167.995L0.000488281 782.995Z" fill="#3B86FF"/>
          </g>
        </svg>
      </div>

      <Container className="myka-v2-contact-cta__inner">
        <Row className="align-items-center">
          <Col xs={12} lg={6}>
            {heading && (
              <h2 className="myka-v2-contact-cta__heading">{heading}</h2>
            )}
          </Col>

          <Col xs={12} lg={6} className="myka-v2-contact-cta__cta-col">
            {body && (
              <p className="myka-v2-contact-cta__subheading">{body}</p>
            )}
            {email && (
              <a
                href={`mailto:${email}`}
                className="myka-v2-contact-cta__email-btn"
              >
                {ctaLabel || email}
              </a>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default MykaV2ContactCta
